<!-- <div>
  <mat-slide-toggle class="ToggleButton" (change)="ToggleDakMode()"
    >Dark Mode</mat-slide-toggle
  >
</div> -->

<nav
  class="navbar navbar-expand-lg navbar-dark bg-primary fixed-top"
  id="sideNav"
>
  <a class="navbar-brand js-scroll-trigger" href="#page-top">
    <span class="d-block d-lg-none">Vishal Jaiswal</span>
    <span class="d-none d-lg-block">
      <img
        class="img-fluid img-profile rounded-circle mx-auto mb-2"
        src="../assets/img/profile.jpg"
        alt=""
      />
    </span>
  </a>
  <button
    class="navbar-toggler"
    type="button"
    data-toggle="collapse"
    data-target="#navbarSupportedContent"
    aria-controls="navbarSupportedContent"
    aria-expanded="false"
    aria-label="Toggle navigation"
  >
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#about">About</a>
      </li>
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#experience">Experience</a>
      </li>
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#projects">Projects</a>
      </li>
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#education">Education</a>
      </li>
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#skills">Skills</a>
      </li>
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#interests">Interests</a>
      </li>
      <li class="nav-item">
        <a class="nav-link js-scroll-trigger" href="#awards">Awards</a>
      </li>
    </ul>
  </div>
</nav>

<div class="container-fluid p-0">
  <section
    class="resume-section p-3 p-lg-5 d-flex align-items-center"
    id="about"
  >
  <app-about></app-about>
  </section>

  <hr class="m-0" />

  <section
    class="resume-section p-3 p-lg-5 d-flex justify-content-center"
    id="experience"
  >
 <app-experience></app-experience>
  </section>

  <hr class="m-0" />

  <section
    class="resume-section p-3 p-lg-5 d-flex justify-content-center"
    id="projects"
  >
  <app-project></app-project>
  </section>

  <hr class="m-0" />

  <section
    class="resume-section p-3 p-lg-5 d-flex align-items-center"
    id="education"
  >
   <app-education></app-education>
  </section>

  <hr class="m-0" />

  <section
    class="resume-section p-3 p-lg-5 d-flex align-items-center"
    id="skills"
  >
   <app-skill></app-skill>
  </section>

  <hr class="m-0" />

  <section
    class="resume-section p-3 p-lg-5 d-flex align-items-center"
    id="interests"
  >
<app-interest></app-interest>
  </section>

  <hr class="m-0" />

  <section
    class="resume-section p-3 p-lg-5 d-flex align-items-center"
    id="awards"
  >
   <app-achievement></app-achievement>
  </section>
</div>
